import React from 'react';
import { BpmTable } from './BpmTable';
import { getMonthName } from './utils';

export const MarketComparisonTable = ({ rawData }) => {
    if (!rawData) {
        return null;
    }
    const rowsAndCols = getTableRowsAndCols(rawData);
    return (
        <BpmTable
            cols={rowsAndCols.cols}
            data={rowsAndCols.rows}
        />
    );
}

function getTableRowsAndCols(rawData) {
    const result = {
        rows: [], cols: [
            {
                title: 'Manufacturer', field: 'manufacturerName'
            }
        ]
    };
    const rowsByManufacturer = new Map();
    const dates = new Set();

    // Create a column for each month-year combination, and populate each row.
    for (const data of rawData) {
        const manufacturerName = data.manufacturerName;
        let row;
        if (rowsByManufacturer.has(manufacturerName)) {
            row = rowsByManufacturer.get(manufacturerName);
        } else {
            row = { manufacturerName: data.manufacturerName };
            rowsByManufacturer.set(manufacturerName, row);
            result.rows.push(row);
        }

        const month = getMonthName(data.month);
        const dateColName = `${month}-${data.year}`;
        row[dateColName] = data.rank;
        const monthAndYear = `${data.year}-${data.month.toString().padStart(2, '0')}`
        if (!dates.has(monthAndYear)) {
            dates.add(monthAndYear);
        }
    }

    // Add date columns by year and then month
    const dateCols = Array.from(dates)
        .sort()
        .map(d => {
            const elements = d.split('-');
            const month = getMonthName(parseInt(elements[1]));
            const year = elements[0];
            const colName = `${month}-${year}`;
            return {
                title: colName,
                field: colName
            };
        });

    result.cols.push(...dateCols);
    return result;
}